import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { GlobalStyles } from './styles/GlobalStyles';

// Lazy loading de componentes
const AdminLogin = lazy(() => import('./components/AdminLogin'));
const Dashboard = lazy(() => import('./components/Dashboard.tsx'));
const OrderHistory = lazy(() => import('./components/OrderHistory.tsx'));
const SalesAnalytics = lazy(() => import('./components/SalesAnalytics.tsx'));
const ProtectedRoute = lazy(() => import('./components/ProtectedRoute.tsx'));

// Componente de carga
const Loading = () => <div className="loading-spinner">Cargando...</div>;

function App() {
  return (
    <AuthProvider>
      <Router>
        <GlobalStyles />
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/login" element={<AdminLogin />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/orders" 
              element={
                <ProtectedRoute>
                  <OrderHistory />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/analytics" 
              element={
                <ProtectedRoute>
                  <SalesAnalytics />
                </ProtectedRoute>
              } 
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
  );
}

export default App;